/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { createStyles, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Container } from "@material-ui/core";
import { colors } from "../../styles/defaultColors";
import { CircularProgress } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { ISnackbar } from "../../utils/enum/snackBarType";
import { Button } from "@material-ui/core";
import Spin from "../../images/Spin";
import { AfriqSnackbar } from "../components/OverridingMaterial/AfriqSnackbar";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        account: {
            background: "#F7F7F7", //03265 061 29
            paddingTop: 27,
            paddingBottom: 27,
        },

        personalInfoContainer: {
            height: "auto",
            borderRadius: 8,
            padding: "30px !important",
            background: "#ffffff",
        },
        info: {
            background: "#ffffff",
        },
        icon: {
            position: "relative",
            top: -4,
        },

        input: {
            "&::placeholder": {
                textOverflow: "ellipsis !important",
                color: "#000000",
                opacity: 10,
            },
        },
        updateInfosButtonsContainer: {
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            alignItems: "center",
        },
        button: {
            background: "#890608",
            color: "white",
            borderRadius: 100,
            fontFamily: "Josefin Sans",
            fontSize: 14,
            textTransform: "none",
            padding: "8px 14px",
            marginLeft: 20,
            "&:hover": {
                background: "#B5551B",
            },
        },
        updateButton: {
            borderRadius: 100,
            textTransform: "none",
            fontSize: 14,
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2),
            textAlign: "center",
            fontFamily: "Josefin Sans",
            background: "#AAAAAA",
            color: "#ffffff",
            padding: "8px 14px",
            "&:hover": {
                background: "#B5551B",
            },
        },
        errors: {
            color: colors.danger,
            background: colors.backgroundDanger,
            width: "100%",
            textAlign: "center",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            borderRadius: 5,
            "& p": {
                padding: 10,
            },
        },
        label: {
            fontFamily: "Josefin Sans",
            fontSize: 16,
            color: "#000000",
        },
        "@global": {
            ".MuiInputBase-input": {
                fontFamily: "Josefin Sans",
                fontSize: 14,
                color: "#000000",
            },
            ".MuiInputBase-input::placeholder": {
                opacity: 0.7,
            },
        },
    })
);

export const Accounts = () => {
    const classes = useStyles();
    const [snackValues, setSnackValues] = React.useState<ISnackbar>({
        type: "success",
        open: false,
        message: "",
    });

    const [loading, setLoading] = React.useState(false);
    const [isUpdating, setIsUpdating] = React.useState(false);
    const { t } = useTranslation();

    const handleCloseSnackbar = () => {
        setSnackValues({ ...snackValues, open: false });
    };

    const triggerUpdatingForm = () => {
        setIsUpdating(!isUpdating);
    };

    const cancelUpdatingForm = () => {
        setIsUpdating(false);
    };

    return (
        <div className={classes.account}>
            <Container>
                <Grid
                    container
                    spacing={2}
                    style={{ justifyContent: "space-around" }}
                >
                    {loading && (
                        <CircularProgress
                            size={32}
                            style={{ color: "#890608" }}
                        />
                    )}
                    {!loading && (
                        <>
                            <Grid item lg={3} sm={12}>
                                nav side
                            </Grid>
                            <Grid
                                item
                                lg={8}
                                sm={12}
                                className={classes.personalInfoContainer}
                            >
                                <Grid container spacing={2}>
                                    <div
                                        className={
                                            classes.updateInfosButtonsContainer
                                        }
                                    >
                                        <Button
                                            className={classes.updateButton}
                                            onClick={
                                                isUpdating
                                                    ? cancelUpdatingForm
                                                    : triggerUpdatingForm
                                            }
                                        >
                                            {isUpdating
                                                ? t("Profil.buttonCancelUpdate")
                                                : t("Profil.buttonUpdate")}
                                        </Button>

                                        {isUpdating && (
                                            <Button
                                                size="small"
                                                type="submit"
                                                className={classes.button}
                                                endIcon={
                                                    loading ? <Spin /> : null
                                                }
                                                disabled={loading}
                                            >
                                                {t("Profil.buttonSave")}
                                            </Button>
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                        </>
                    )}
                </Grid>
                <AfriqSnackbar
                    {...snackValues}
                    handleClose={handleCloseSnackbar}
                />
            </Container>
        </div>
    );
};
